<div class="favorite-button-wrapper">
	<i #anchor
	   class="favorite-button"
	   [ngClass]="{
	'cp-icon-favorite_remove': isFavorite,
	'cp-icon-favorite_add': !isFavorite,
	'disabled': disabled,
	'max-favorites-number-reached': isMaxFavoritesNumber
   }"
	   (click)="clickHandler()">
	</i>
	<cp-tooltip *ngIf="isFavorite"
				class="bgc-white"
				[direction]="'top'"
				[anchor]="anchor"
				[contentPadding]="5">
		{{dictionary.removeFromFavorites | cpActionTranslate}}
	</cp-tooltip>
	<cp-tooltip *ngIf="!isFavorite && isMaxFavoritesNumber"
				class="bgc-white"
				[direction]="'top'"
				[anchor]="anchor"
				[contentPadding]="5">
		{{dictionary.maxFavoritesReached | cpActionTranslate}}
	</cp-tooltip>
	<cp-tooltip *ngIf="!isFavorite && !isMaxFavoritesNumber"
				class="bgc-white"
				[direction]="'top'"
				[anchor]="anchor"
				[contentPadding]="5">
		{{dictionary.addToFavorites | cpActionTranslate}}
	</cp-tooltip>
</div>

